import * as React from "react";
import { Helmet } from "react-helmet";
import CaseStudyHeroSection from "./../../templates/caseStudy/caseStudyPageTemplate";
import FooterSection from "./../../templates/footer";
import NavBar from "./../../templates/navbar";

import caseStudyService from "./../../modules/caseStudyService";
let caseStudy = caseStudyService.caseStudyList["gynoveda"];

// markup
const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="description" content="Gynoveda sees over 15X conversions after partnering with Growlytics." />
        <meta property="og:image" content={caseStudy.image} />
        <meta name="google" content="nositelinkssearchbox" />
        <title>Growlytics - {caseStudy.company} sees over 15X conversions after partnering with Growlytics.</title>
        <link rel="canonical" href="/" />
      </Helmet>

      <NavBar></NavBar>

      {/* Hero Section */}
      <CaseStudyHeroSection case={caseStudy} heavyBackground={true}></CaseStudyHeroSection>

      {/* Add Footer */}
      <FooterSection></FooterSection>
    </main>
  );
};

export default IndexPage;
